"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.surfaceStyles = exports.surfaceBaseStyles = void 0;
const lit_1 = require("lit");
const utils_1 = require("@/utils");
/**
 * variant별로 재정의하는 surface 컴포넌트 토큰. 이 오브젝트가 실제 :host([variant=...]) 규칙을
 * 생성하는 유일한 소스다(아래 surfaceVariantStyles 참고). 키가 컴포넌트 토큰 이름이라
 * 리액트로 옮길 때도 같은 이름의 CSS 커스텀 프로퍼티를 그대로 재사용할 수 있다.
 */
const surfaceVariants = {
    ghost: {
        '--surface-border': 'var(--border-transparent)',
        '--surface-background-color': 'none',
    },
    paper: {
        '--surface-border': 'var(--border-transparent)',
        '--surface-background-color': 'var(--background-color)',
    },
    outlined: {},
    filled: {
        '--surface-border': 'var(--border-transparent)',
        '--surface-background-color': 'var(--background-subtle-color)',
    },
    elevated: {
        '--surface-shadow': 'var(--material-elevated-shadow)',
    },
};
/**
 * surface 면 선언. 면을 맡을 선택자는 사용부가 정한다.
 * 모든 값이 --surface-* 토큰을 거치므로 variant든 선택·hover 상태든
 * 속성을 다시 선언하지 않고 토큰만 재할당한다.
 */
exports.surfaceBaseStyles = (0, lit_1.css) `
  --surface-height: auto;
  --surface-padding: var(--space-4);
  --surface-border: var(--border);
  --surface-border-radius: var(--radius);
  --surface-background-color: var(--background-color);
  --surface-text-color: inherit;
  --surface-shadow: none;

  display: flex;
  flex-direction: column;
  height: var(--surface-height);
  width: 100%;
  padding: var(--surface-padding);
  border: var(--surface-border);
  border-radius: var(--surface-border-radius);
  box-sizing: border-box;
  background: var(--surface-background-color);
  color: var(--surface-text-color);
  box-shadow: var(--surface-shadow);

  position: relative;
  transition: box-shadow var(--transition-duration) var(--transition-easing);
`;
const surfaceRadiusTokens = {
    default: { '--surface-border-radius': 'var(--radius)' },
    large: { '--surface-border-radius': 'var(--radius-large)' },
};
const surfaceRadiusStyles = (0, lit_1.css) `
  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('radius', surfaceRadiusTokens))}
`;
const surfaceDensityTokens = {
    default: { '--surface-padding': 'var(--space-4)' },
    compact: { '--surface-padding': 'var(--space-2)' },
};
const surfaceDensityStyles = (0, lit_1.css) `
  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('density', surfaceDensityTokens))}
`;
const surfaceVariantStyles = (0, lit_1.css) `
  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('variant', surfaceVariants))}
`;
exports.surfaceStyles = [
    (0, lit_1.css) `
    :host {
      ${exports.surfaceBaseStyles};
    }
  `,
    surfaceRadiusStyles,
    surfaceDensityStyles,
    surfaceVariantStyles,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VyZmFjZS5zdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzdXJmYWNlLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBb0M7QUFFcEMsbUNBQW1FO0FBTW5FOzs7O0dBSUc7QUFDSCxNQUFNLGVBQWUsR0FBbUQ7SUFDdEUsS0FBSyxFQUFFO1FBQ0wsa0JBQWtCLEVBQUUsMkJBQTJCO1FBQy9DLDRCQUE0QixFQUFFLE1BQU07S0FDckM7SUFDRCxLQUFLLEVBQUU7UUFDTCxrQkFBa0IsRUFBRSwyQkFBMkI7UUFDL0MsNEJBQTRCLEVBQUUseUJBQXlCO0tBQ3hEO0lBQ0QsUUFBUSxFQUFFLEVBQUU7SUFDWixNQUFNLEVBQUU7UUFDTixrQkFBa0IsRUFBRSwyQkFBMkI7UUFDL0MsNEJBQTRCLEVBQUUsZ0NBQWdDO0tBQy9EO0lBQ0QsUUFBUSxFQUFFO1FBQ1Isa0JBQWtCLEVBQUUsaUNBQWlDO0tBQ3REO0NBQ0YsQ0FBQTtBQUVEOzs7O0dBSUc7QUFDVSxRQUFBLGlCQUFpQixHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXVCbkMsQ0FBQTtBQUVELE1BQU0sbUJBQW1CLEdBQW1DO0lBQzFELE9BQU8sRUFBRSxFQUFFLHlCQUF5QixFQUFFLGVBQWUsRUFBRTtJQUN2RCxLQUFLLEVBQUUsRUFBRSx5QkFBeUIsRUFBRSxxQkFBcUIsRUFBRTtDQUM1RCxDQUFBO0FBRUQsTUFBTSxtQkFBbUIsR0FBRyxJQUFBLFNBQUcsRUFBQTtJQUMzQixJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLFFBQVEsRUFBRSxtQkFBbUIsQ0FBQyxDQUFDO0NBQ2hFLENBQUE7QUFFRCxNQUFNLG9CQUFvQixHQUFvQztJQUM1RCxPQUFPLEVBQUUsRUFBRSxtQkFBbUIsRUFBRSxnQkFBZ0IsRUFBRTtJQUNsRCxPQUFPLEVBQUUsRUFBRSxtQkFBbUIsRUFBRSxnQkFBZ0IsRUFBRTtDQUNuRCxDQUFBO0FBRUQsTUFBTSxvQkFBb0IsR0FBRyxJQUFBLFNBQUcsRUFBQTtJQUM1QixJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLFNBQVMsRUFBRSxvQkFBb0IsQ0FBQyxDQUFDO0NBQ2xFLENBQUE7QUFFRCxNQUFNLG9CQUFvQixHQUFHLElBQUEsU0FBRyxFQUFBO0lBQzVCLElBQUEsZUFBUyxFQUFDLElBQUEsMkJBQW1CLEVBQUMsU0FBUyxFQUFFLGVBQWUsQ0FBQyxDQUFDO0NBQzdELENBQUE7QUFFWSxRQUFBLGFBQWEsR0FBRztJQUMzQixJQUFBLFNBQUcsRUFBQTs7UUFFRyx5QkFBaUI7O0dBRXRCO0lBQ0QsbUJBQW1CO0lBQ25CLG9CQUFvQjtJQUNwQixvQkFBb0I7Q0FDckIsQ0FBQSJ9